<template>
  <figure
    :class="[
      { TextMediaElement__mediaRight: mediaRight },
      { TextMediaElement__mediaLeft: mediaLeft },
      $style.container,
    ]"
  >
    <div :class="$style.mediaWrapper">
      <HeroSlider v-if="slides" :slides="slides" />
      <button
        v-if="video || youtube"
        :class="[$style.mediaLink, $style.videoLink]"
        @click="openModal"
      >
        <i class="fab fa-youtube" />
        <img :alt="title" :src="image" />
        <span class="accessible-link-text">{{ 'Video:' + title }}</span>
      </button>
      <div v-else-if="!slides?.length && (!video || !youtube)" :class="[$style.mediaLink]">
        <img v-if="image" :alt="imageAlt || title" :src="image" />
      </div>
    </div>
    <figcaption>
      <div v-if="badge" :class="[$style.badgeContainer, isTimeline && $style.timelineBadge]">
        <Badge :class="$style.badge" color="blue" size="lg" :text="badge" />
      </div>
      <h5 class="Font__h5">{{ title }}</h5>
      <!-- eslint-disable-next-line max-len -->
      <div class="Font__copy_s_regular" v-html="text" />
    </figcaption>
    <Modal
      v-if="video || youtube"
      :is-modal-open="isModalOpen"
      :is-not-you-tube="isTimeline ? !youtube : !!video"
      :is-video="true"
      @close-modal="closeModal"
    >
      <video v-if="video" ref="videoRef" controls height="100%" :poster="props?.image" width="100%">
        <source v-if="isMp4" :src="video" type="video/mp4" />
        <source v-else :src="video" type="video/webm" />
      </video>
      <iframe
        v-else-if="youtube"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        frameborder="0"
        referrerpolicy="strict-origin-when-cross-origin"
        :src="youtube"
        :title="`Youtube video: ${title}`"
      ></iframe>
    </Modal>
  </figure>
</template>

<script setup>
import { ref } from 'vue';
import HeroSlider from '../HeroSlider/HeroSlider.vue';
import Modal from '../Modal/Modal.vue';
import Badge from '../Badge/Badge.vue';

const props = defineProps({
  mediaRight: {
    type: Boolean,
    default: false,
  },
  isMp4: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
  slides: {
    type: Array,
    default: () => [],
  },
  video: {
    type: String,
    default: '',
  },
  image: {
    type: String,
    default: '',
  },
  youtube: {
    type: String,
    default: '',
  },
  mediaLeft: {
    type: Boolean,
    optional: true,
    default: null,
  },
  badge: {
    type: String,
    optional: true,
    default: null,
  },
  isTimeline: {
    type: Boolean,
    options: true,
    default: false,
  },
  imageAlt: {
    type: String,
    optional: true,
    default: undefined,
  },
});

const isModalOpen = ref(false);
const videoRef = ref(null);

const openModal = () => {
  isModalOpen.value = true;

  if (videoRef.value) {
    videoRef.value.load();
  }
};
const closeModal = () => {
  if (videoRef.value) {
    videoRef.value.pause();
  }

  isModalOpen.value = false;
};
</script>

<style module lang="scss">
@forward '../Wysiwyg/Wysiwyg.scss';
@forward './TextMediaElement.scss';
</style>
